var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWebPublishing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 550,
    height: 550,
    viewBox: "0 0 550 550",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "q2vuhf8r1a",
    d: "M0 0.692L476.583 0.692 476.583 431.998 0 431.998z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "j56r91fnac",
    d: "M0 431.998L476.583 431.998 476.583 0.692 0 0.692z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF597",
    d: "M444.854 418.874L32.775 418.874 35.746 148.05 447.826 148.05z",
    transform: "translate(36.5 58)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.5 58) translate(0 .31)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M222.328 333.481c-1.01 0-2.037-.18-3.036-.563-4.396-1.677-6.598-6.601-4.92-10.998l43.738-114.578c1.677-4.395 6.602-6.601 10.995-4.92 4.395 1.678 6.598 6.603 4.92 10.999l-43.738 114.577c-1.296 3.396-4.53 5.483-7.96 5.483M184.54 308.767c-1.453 0-2.926-.372-4.274-1.156l-62.44-36.32c-2.72-1.583-4.346-4.537-4.228-7.683.117-3.145 1.96-5.97 4.79-7.345l65.59-31.868c4.23-2.057 9.328-.292 11.382 3.941 2.057 4.233.292 9.33-3.939 11.385l-51.207 24.88 48.617 28.28c4.066 2.367 5.446 7.58 3.08 11.648-1.581 2.72-4.436 4.238-7.37 4.238M290.022 308.768c-2.994 0-5.898-1.583-7.455-4.386-2.283-4.114-.8-9.3 3.313-11.585l51.406-28.543-48.34-24.602c-4.193-2.134-5.862-7.264-3.729-11.457 2.133-4.194 7.262-5.862 11.454-3.73l62.617 31.868c2.807 1.428 4.597 4.29 4.654 7.439.056 3.15-1.628 6.074-4.382 7.602l-65.411 36.321c-1.31.727-2.728 1.072-4.127 1.073"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "1ocwfi59nb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#q2vuhf8r1a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M47.156 17.73c-17.171 0-30.12 12.646-30.12 29.414v338.401c0 16.219 12.178 29.413 27.148 29.413H432.4c14.969 0 27.148-13.194 27.148-29.413V47.144c0-16.835-12.764-29.413-24.177-29.413H47.156zM432.4 431.999H44.184C19.82 431.998 0 411.159 0 385.545V47.144C0 20.662 20.273.69 47.156.69h388.215c21.954 0 41.212 21.708 41.212 46.453v338.401c0 25.614-19.82 46.453-44.183 46.453z",
    mask: "url(#1ocwfi59nb)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "7w7adg705d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#j56r91fnac"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2E036A",
    d: "M4.306 104.514L476.296 104.514 476.296 87.475 4.306 87.475zM143.166 60.76H43.87c-4.981 0-9.019-4.039-9.019-9.021 0-4.983 4.038-9.021 9.02-9.021h99.295c4.982 0 9.02 4.038 9.02 9.02 0 4.983-4.038 9.021-9.02 9.021M310.617 60.76h-18.302c-4.98 0-9.019-4.039-9.019-9.021 0-4.983 4.039-9.021 9.02-9.021h18.301c4.982 0 9.02 4.038 9.02 9.02 0 4.983-4.038 9.021-9.02 9.021M366.352 60.311h-18.864c-4.98 0-9.018-4.038-9.018-9.02 0-4.983 4.038-9.021 9.018-9.021h18.864c4.981 0 9.019 4.038 9.019 9.02 0 4.983-4.038 9.021-9.019 9.021M422.283 60.311H403.42c-4.98 0-9.02-4.038-9.02-9.02 0-4.983 4.04-9.021 9.02-9.021h18.863c4.982 0 9.02 4.038 9.02 9.02 0 4.983-4.038 9.021-9.02 9.021",
    mask: "url(#7w7adg705d)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWebPublishing);
export default __webpack_public_path__ + "static/media/icon--web-publishing.958d33e85eae5dc1823b4bed3e8b6a06.svg";
export { ForwardRef as ReactComponent };